/**
 * Width the page lays out at, in CSS pixels — the width CSS media queries see.
 *
 * When content overflows, the Android WebView zooms out (`visualViewport.scale` < 1) and
 * `window.innerWidth` grows with it (e.g. 1083 instead of 800). A layout decided from that
 * value keeps the overflowing wide branch and locks itself in. `documentElement.clientWidth`
 * stays at the layout width. Pinch-zoom in (scale > 1) and the default zoom keep
 * `window.innerWidth`, so desktop browsers behave as before.
 *
 * @returns {number | undefined} undefined during SSR
 */
export const getLayoutWidth = () => {
  if (typeof window === 'undefined') return undefined;
  const scale = window.visualViewport?.scale;
  return scale < 1 ? document.documentElement.clientWidth : window.innerWidth;
};
